import { useFormikContext } from 'formik';
import { observer } from 'mobx-react';
import { Button, Form, Spinner } from 'react-bootstrap';

const SprayDataForm = ({ onCancel }) => {
  const {
    values,
    errors,
    isSubmitting,
    handleSubmit,
    handleChange,
    handleBlur
  } = useFormikContext();

  return (
    <>
      <Form noValidate onSubmit={handleSubmit}>
        <Form.Group className='mb-3' controlId='date'>
          <Form.Label>Date</Form.Label>
          <Form.Control
            type='date'
            onChange={handleChange}
            onBlur={handleBlur}
            value={(values.date || '').slice(0, 10)}
            placeholder='Select date'
            isInvalid={!!errors.date}
          />
          <Form.Control.Feedback type='invalid'>
            {errors.date}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className='mb-3' controlId='product_name'>
          <Form.Label>Product Name</Form.Label>
          <Form.Control
            type='text'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.product_name || ''}
            placeholder=''
            isInvalid={!!errors.product_name}
          />
          <Form.Control.Feedback type='invalid'>
            {errors.product_name}
          </Form.Control.Feedback>
        </Form.Group>
        <Button variant='primary' type='submit'>
          {isSubmitting ? (
            <Spinner className='mx-3' animation='border' size='sm' />
          ) : (
            'Submit'
          )}
        </Button>
        <Button variant='secondary' type='button' onClick={onCancel}>
          Cancel
        </Button>
      </Form>
    </>
  );
};

export default observer(SprayDataForm);

